var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"page-index"},[_c('el-aside',[_c('public-aside')],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }